import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';

interface AddAudienceButtonProps {
  readonly collapsed: boolean;
}

/**
 * "+ Add new audience".
 *
 * An audience is built in the Funnel — that is the only flow in the app that
 * creates one — so the button opens it. If product means something else by
 * "new audience" (a flat segment, saved straight from Discovery), this is the
 * one line that changes.
 */
export const AddAudienceButton: React.FC<AddAudienceButtonProps> = ({ collapsed }) => {
  const { t } = useTranslation();
  const label = t('app.v11.shell.addAudience');

  if (collapsed) {
    return (
      <Link
        to="/v11/funnel"
        aria-label={label}
        title={label}
        className="flex h-10 w-10 items-center justify-center rounded-[10px] bg-v11-cta-bg text-v11-cta-text transition hover:opacity-90"
      >
        <Plus className="h-4 w-4" />
      </Link>
    );
  }

  return (
    <Link
      to="/v11/funnel"
      className="flex h-10 w-full items-center justify-center rounded-[12px] bg-v11-cta-bg px-4 text-[14px] font-semibold leading-5 text-v11-cta-text transition hover:opacity-90"
    >
      <span aria-hidden="true">+&nbsp;</span>
      {label}
    </Link>
  );
};
